import { getComissionadoNormalized } from '../plugins/helpers'

export default {
  methods: {
    async realizarVenda (id_pedido, forma_pagamento, bandeira_cartao, gerar_contrato = false, retentativa_carrinho = false, alterar_pagamento = false) {
      const id_comissionado = this.$session.get('id_comissionado_venda')
      const id_unidade_negocio = this.$session.get('id_unidade_negocio')
      const id_empresa = this.$session.get('id_empresa')
      const comissionado = getComissionadoNormalized(id_comissionado, this.$session.get('comissionados'), this.$session.get('vendas_backoffice'))
      const unidade_negocio = this.$session.get('unidades').find(unidade => unidade.id_unidade_negocio === id_unidade_negocio)
      const empresa = this.$session.get('empresas').find(empresa => empresa.ID_Empresa === id_empresa)

      return this.$http.post('/proposta/web', {
        id_pedido: id_pedido,
        forma_pagamento: forma_pagamento,
        bandeira_cartao: bandeira_cartao,
        comissionado,
        unidade_negocio,
        empresa,
        origem_acesso: this.$session.get('origem_acesso'),
        id_empresa: this.$session.get('id_empresa'),
        gerar_contrato,
        retentativa_carrinho,
        alterar_pagamento
      })
    },
    async realizarVendaCarrinhoAtreladoPagamento (id_pedido, forma_pagamento, bandeira_cartao, cartao, id_usuario, gerar_contrato = false) {
      this.$store.commit('setAdditionalLoadingText', 'Processando a transação do cartão, este processo pode levar alguns minutos!')

      const id_comissionado = this.$session.get('id_comissionado_venda')
      const id_unidade_negocio = this.$session.get('id_unidade_negocio')
      const id_empresa = this.$session.get('id_empresa')
      const comissionado = getComissionadoNormalized(id_comissionado, this.$session.get('comissionados'), this.$session.get('vendas_backoffice'))
      const unidade_negocio = this.$session.get('unidades').find(unidade => unidade.id_unidade_negocio === id_unidade_negocio)
      const empresa = this.$session.get('empresas').find(empresa => empresa.ID_Empresa === id_empresa)
      return this.$http.post('/proposta/carrinho/pagar_vinculado_geracao', {
        id_pedido: id_pedido,
        forma_pagamento: forma_pagamento,
        bandeira_cartao: bandeira_cartao,
        comissionado,
        id_usuario: id_usuario,
        cartao: cartao,
        unidade_negocio,
        empresa,
        origem_acesso: this.$session.get('origem_acesso'),
        id_empresa: this.$session.get('id_empresa'),
        gerar_contrato
      }, { options: { showAdditionalLoadingText: true } })
    },
    async realizarVendaCarrinhoComLink (id_pedido, forma_pagamento, bandeira_cartao, id_usuario, email) {
      const id_comissionado = this.$session.get('id_comissionado_venda')
      const id_unidade_negocio = this.$session.get('id_unidade_negocio')
      const id_empresa = this.$session.get('id_empresa')
      const comissionado = getComissionadoNormalized(id_comissionado, this.$session.get('comissionados'), this.$session.get('vendas_backoffice'))
      const unidade_negocio = this.$session.get('unidades').find(unidade => unidade.id_unidade_negocio === id_unidade_negocio)
      const empresa = this.$session.get('empresas').find(empresa => empresa.ID_Empresa === id_empresa)
      return this.$http.post('/proposta/carrinho/gerar_link_carrinho', {
        id_pedido: id_pedido,
        forma_pagamento: forma_pagamento,
        bandeira_cartao: bandeira_cartao,
        comissionado,
        id_usuario: id_usuario,
        unidade_negocio,
        empresa,
        origem_acesso: this.$session.get('origem_acesso'),
        id_empresa: this.$session.get('id_empresa'),
        email
      })
    }
  }
}
